import React, { useState, useEffect} from "react";
import axios from 'axios';
import Cookies from 'js-cookie';


import Loader from "../static/svg/loaderImage.svg"
import userEvent from "@testing-library/user-event";

import SwiperCore, { Autoplay, EffectFade, EffectFlip } from 'swiper';
import { Swiper, SwiperSlide } from "swiper";

import 'swiper/swiper.min.css'
import 'swiper/modules/autoplay/autoplay.min.css'
import 'swiper/modules/pagination/pagination.min.css'
import 'swiper/modules/effect-fade/effect-fade.min.css'
import 'swiper/modules/effect-flip/effect-flip.min.css'

const base_url = 'https://www.keswin.app';
// const base_url = 'http://0.0.0.0:8000';
SwiperCore.use([Autoplay, EffectFlip, EffectFade])

// ============================================================
// DISPLAY SCRAMBLE FIX
// The physical display scrambles the bottom two rows (4 and 5)
// as a COMBINED 1536px region. When SCRAMBLE_ENABLED, we merge
// rows 4+5 into a single 40vh swiper and pre-scramble the output
// per SCRAMBLE_SEGMENTS so the hardware un-scrambles it correctly.
// ============================================================
const SCRAMBLE_ENABLED = true;
const COMBINED_HEIGHT = 1536; // 768 * 2, bottom two rows combined
const COMBINED_VH = 40; // 20vh * 2
const SINGLE_ROW_VH = 20;

// Hardware scramble mapped from baseline band test (2026-04-30).
// Coordinate origin is the top of row 4 (the combined region spans
// rows 4+5, source 0–1536). Row 3 is unscrambled and rendered
// independently, so it does not appear here.
//
//   - Source 0–576 (top half of row 4) passes through unscrambled.
//   - Source 576–1536 is broken into 7 segments, all hardware-flipped:
//       screen 576–704  ← source 768–896  (band I top)
//       screen 704–896  ← source 576–768  (band H whole)
//       screen 896–960  ← source 1152–1216 (band K top)
//       screen 960–1152 ← source 960–1152  (band J whole)
//       screen 1152–1216 ← source 896–960  (band I bottom)
//       screen 1216–1408 ← source 1344–1536 (band L whole)
//       screen 1408–1536 ← source 1216–1344 (band K main)
// Each entry below pre-renders desired[srcY:srcY+h] (flipped if needed)
// at video position [y:y+h], so the hardware un-scrambles to correct.
const SCRAMBLE_SEGMENTS = [
  { y: 0,    h: 576, srcY: 0,    flip: false }, // unscrambled top half of row 4
  { y: 576,  h: 192, srcY: 704,  flip: true  }, // → screen 704–896  (H whole)
  { y: 768,  h: 128, srcY: 576,  flip: true  }, // → screen 576–704  (I top)
  { y: 896,  h: 64,  srcY: 1152, flip: true  }, // → screen 1152–1216 (I bottom)
  { y: 960,  h: 192, srcY: 960,  flip: true  }, // → screen 960–1152 (J whole)
  { y: 1152, h: 64,  srcY: 896,  flip: true  }, // → screen 896–960  (K top)
  { y: 1216, h: 128, srcY: 1408, flip: true  }, // → screen 1408–1536 (K main)
  { y: 1344, h: 192, srcY: 1216, flip: true  }, // → screen 1216–1408 (L whole)
];

// Calibration bands — 8 evenly-sized bands across the 1536px region,
// 192px each. Hues at ~45° intervals; all dark enough for white text.
// Letters not numbers so flips are unambiguous.
const BAND_COUNT = 8;
const BAND_HEIGHT = COMBINED_HEIGHT / BAND_COUNT;
const BANDS = [
  { letter: 'A', color: '#C62828' }, // deep red
  { letter: 'B', color: '#E65100' }, // deep orange
  { letter: 'C', color: '#827717' }, // olive
  { letter: 'D', color: '#2E7D32' }, // forest green
  { letter: 'E', color: '#00838F' }, // dark teal
  { letter: 'F', color: '#1565C0' }, // royal blue
  { letter: 'G', color: '#6A1B9A' }, // deep purple
  { letter: 'H', color: '#AD1457' }, // magenta
];

const toVh = (px) => (px / COMBINED_HEIGHT * COMBINED_VH);

// ============================================================
// TEST MODE
// Bypasses the API and renders canvas-generated calibration
// patterns so you can map the hardware scramble on the physical display.
//
// Row 1-3: solid coloured panels labelled ROW 1/2/3
// Rows 4+5: 8 lettered bands (A–H, 192px each) covering the
//   1536px scrambled region. Each band shows its letter, pixel
//   labels every 32px down the left edge, and an UP arrow.
//
// To map the scramble: read the band letter and pixel labels in each
// fragment top-to-bottom on the physical display, note any flipped
// arrows / upside-down labels, and translate that into SCRAMBLE_SEGMENTS
// entries (y = position on screen, srcY = source pixel position the
// fragment came from, flip = arrow points down).
//
// Set TEST_MODE = false to restore normal operation.
// ============================================================
const TEST_MODE = false;

function generateRowTestImage(label, bgColor) {
  const W = 810, H = 768;
  const canvas = document.createElement('canvas');
  canvas.width = W; canvas.height = H;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = bgColor;
  ctx.fillRect(0, 0, W, H);
  ctx.strokeStyle = 'rgba(255,255,255,0.15)';
  ctx.lineWidth = 1;
  for (let y = 0; y < H; y += 50) { ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(W, y); ctx.stroke(); }
  ctx.fillStyle = 'white';
  ctx.font = 'bold 120px sans-serif';
  ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
  ctx.fillText(label, W / 2, H / 2);
  return canvas.toDataURL();
}

const PX_LABEL_SPACING = 32;

function generateCalibrationHalf(startPx, endPx) {
  // Generates the band pattern from startPx to endPx.
  // row4 calls this with (0, 768), row5 with (768, 1536).
  const W = 810;
  const H = endPx - startPx;
  const canvas = document.createElement('canvas');
  canvas.width = W; canvas.height = H;
  const ctx = canvas.getContext('2d');

  BANDS.forEach((band, i) => {
    const bandTop = i * BAND_HEIGHT;
    const bandBot = bandTop + BAND_HEIGHT;
    const visTop = Math.max(bandTop, startPx);
    const visBot = Math.min(bandBot, endPx);
    if (visBot <= visTop) return;

    const drawY = visTop - startPx;
    const drawH = visBot - visTop;
    const midY = drawY + drawH / 2;

    ctx.fillStyle = band.color;
    ctx.fillRect(0, drawY, W, drawH);

    // Big letter, centered (slightly transparent so left-edge labels stay legible)
    ctx.fillStyle = 'rgba(255,255,255,0.92)';
    ctx.font = `bold ${Math.min(drawH * 0.7, 150)}px sans-serif`;
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.fillText(band.letter, W / 2, midY);

    // Absolute pixel-position labels every PX_LABEL_SPACING down the left edge.
    // Each label is "<absolute-px>" in source coords (0–1535). Read these in a
    // scrambled fragment to know exactly which source pixels you're seeing.
    for (let py = bandTop; py < bandBot; py += PX_LABEL_SPACING) {
      if (py < startPx || py >= endPx) continue;
      const ly = py - startPx;
      // Tick mark
      ctx.strokeStyle = 'rgba(255,255,255,0.7)';
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(0, ly); ctx.lineTo(26, ly);
      ctx.stroke();
      // Label
      ctx.fillStyle = 'white';
      ctx.font = 'bold 28px monospace';
      ctx.textAlign = 'left'; ctx.textBaseline = 'top';
      ctx.fillText(String(py), 30, ly + 4);
    }

    // Up arrow, top-right (points down if hardware flips this band)
    if (visTop === bandTop) {
      const ax = W - 50, ay = drawY + 45, as = 32;
      ctx.fillStyle = 'white';
      ctx.beginPath();
      ctx.moveTo(ax, ay - as);
      ctx.lineTo(ax + as * 0.7, ay + as * 0.5);
      ctx.lineTo(ax - as * 0.7, ay + as * 0.5);
      ctx.closePath();
      ctx.fill();
    }

    // Boundary line at bottom of band
    if (i < BAND_COUNT - 1 && bandBot >= startPx && bandBot <= endPx) {
      const lineY = bandBot - startPx;
      ctx.strokeStyle = 'rgba(255,255,255,0.85)';
      ctx.lineWidth = 3;
      ctx.beginPath(); ctx.moveTo(0, lineY); ctx.lineTo(W, lineY); ctx.stroke();
    }
  });

  return canvas.toDataURL();
}

function buildTestMedias() {
  const rowImages = [
    [{ get_image: generateRowTestImage('ROW 1', '#5a0a0a'), is_portrait: false }],
    [{ get_image: generateRowTestImage('ROW 2', '#0a3a0a'), is_portrait: false }],
    [{ get_image: generateRowTestImage('ROW 3', '#0a0a5a'), is_portrait: false }],
  ];
  const halfH = COMBINED_HEIGHT / 2; // 768px — the 20vh row height on 4K portrait
  const row4Img = generateCalibrationHalf(0, halfH);
  const row5Img = generateCalibrationHalf(halfH, COMBINED_HEIGHT);
  if (!SCRAMBLE_ENABLED) {
    return [
      ...rowImages,
      [{ get_image: row4Img, is_portrait: false }],
      [{ get_image: row5Img, is_portrait: false }],
    ];
  }
  return [
    ...rowImages,
    [{ row4: { get_image: row4Img, is_portrait: false }, row5: { get_image: row5Img, is_portrait: false } }],
  ];
}

function App() {
    // When scramble is enabled, we render 4 swipers: 3 normal (rows 1, 2, 3)
    //   + 1 combined (rows 4+5 merged at 40vh).
    // When disabled, we render the original 5 swipers.
    const frames = SCRAMBLE_ENABLED ? [0, 1, 2, 3] : [0, 1, 2, 3, 4];
    const MEDIA_CHUNKS = 5; // always split media into 5 groups
    const [swiperInit, setSwiperInit] = useState(false);
    const [medias, setMedias] = useState(null);
    const [modified, setModified] = useState(null);
    const [displayModified, setDisplayModified] = useState(null);
    const [transitionEffect, setTransitionEffect] = useState(null);
    const [animInit, setAnimInit] = useState(false);
    const [delay, setDelay] = useState(null);
    const [paused, setPaused] = useState(null);
    const [direction, setDirection] = useState('horizontal');
    const [timeouts, setTimeouts] = useState([]);
    const [pingDateTime, setPingDateTime] = useState(null);

    function pingDisplay() {
      var ping_datetime = new Date();
      axios({
        method: 'post',
        baseURL: base_url,
        url: '/api/ping/1/',
        data: {'ping_datetime': ping_datetime}
        }).then((response) => {
          setPingDateTime(ping_datetime);
        });
    }
   

    function fetchPlaylists() {
      if (TEST_MODE) {
        setMedias(buildTestMedias());
        setDelay(8000);
        setPaused(false);
        setTransitionEffect('fade');
        setDirection('horizontal');
        setTimeout(() => {
          var swipers = document.getElementsByClassName('swiper-container');
          for (var i = 0; i < swipers.length; i++) {
            var swiper = new Swiper('#swiper_' + i, {
              loop: false, slidesPerView: 1, effect: 'fade',
              direction: 'horizontal', speed: 750, autoplay: false,
              on: i === swipers.length - 1 ? { init: () => setSwiperInit(true) } : {}
            });
          }
        }, 100);
        return;
      }

      try {
          const get_url = base_url + '/api/display-media/1/?format=json';
          axios({
              method: 'get',
              url: get_url,
              // headers: {
              //   Authorization: 'Token ' + Cookies.get('ud_token')
              // },
          })
          .then(response => {
              const displayJSON = response.data;
              var allMedia = displayJSON.medias;
              var allMediaLength = allMedia.length;
              var chunkLength = Math.ceil(allMediaLength/MEDIA_CHUNKS);

              console.log(allMedia, allMediaLength, chunkLength)

              const mediaArray = [];

              function chunk(array, size) {
                if (!array) return [];
                const firstChunk = array.slice(0, size);
                if (!firstChunk.length) {
                  return array;
                }
                return [firstChunk].concat(chunk(array.slice(size, array.length), size));
              }

              var chunked = chunk(allMedia, chunkLength);

              // When scramble is enabled, merge chunks 3+4 (rows 4+5) into
              // paired slides for the combined-row swiper.
              if (SCRAMBLE_ENABLED && chunked.length >= 5) {
                var row4Media = chunked[3] || [];
                var row5Media = chunked[4] || [];
                var maxLen = Math.max(row4Media.length, row5Media.length);
                var combinedMedia = [];
                for (var ci = 0; ci < maxLen; ci++) {
                  combinedMedia.push({
                    row4: row4Media[ci % row4Media.length],
                    row5: row5Media[ci % row5Media.length],
                  });
                }
                chunked = [chunked[0], chunked[1], chunked[2], combinedMedia];
              }

              if (chunked) {
                setMedias(chunked);
              }
              console.log('chunked', chunked)
              setModified(displayJSON['modified']);
              setDisplayModified(displayJSON['display_modified']);
              
              // console.log("MEDIA", mediaArray, allMedia, allMedia.length, chunked[0], allMediaLength/frames.length);
              const transition = displayJSON['transition'];
              const delay = displayJSON['timing']['seconds']*1000;
              
              setDelay(delay);
              const paused = displayJSON['paused'];
              console.log('delay', delay, 'paused', paused);
              
              if (transition === 'fade') {
                var transitionVal = 'fade';
                var directionVal = 'horizontal';
              } else if (transition === 'across') {
                var transitionVal = 'slide';
                var directionVal = 'horizontal';
              } else if (transition === 'up') {
                var transitionVal = 'slide';
                var directionVal = 'vertical';
              } else if (transition === 'flip') {
                var transitionVal = 'flip';
                var directionVal = 'vertical';
              } else {
                
              }

              setDirection(directionVal);
              setTransitionEffect(transitionVal);
              // setHasEffect(true);
              setPaused(paused);

              var swiperArray = [];
              var swipers = document.getElementsByClassName('swiper-container');
              var arrayLength = swipers.length;

              // function restartSwipers() {
              //   // counter-=counter;
              //   for (var i = 0; i < arrayLength; i++) {
              //     swipers[i].swiper.autoplay.start();
              //   }
              // }
    
              for (var i = 0; i < arrayLength; i++) {
                if (i === (arrayLength - 1)) {
                  var swiper = new Swiper('#swiper_' + i, {
                    loop: true,
                    slidesPerView: '1',
                    effect: transitionVal,
                    direction: directionVal,
                    speed: 750,
                    centeredSlides: true,
                    loop: false,
                    slidesPerView: 1,
                    autoplay: false,
                    on: {
                      init: function () {
                        
                          setSwiperInit(true);
                          pingDisplay();
        
                      },
                    }
                  });
                  swiperArray.push(swiper);

                } else {
                  var swiper = new Swiper('#swiper_' + i, {
                    loop: true,
                    slidesPerView: '1',
                    effect: transitionVal,
                    direction: directionVal,
                    speed: 750,
                    centeredSlides: true,
                    loop: false,
                    slidesPerView: 1,
                    autoplay: false
                  });
                  swiperArray.push(swiper);


                }
               
              }

              
          });
      } catch (error) {
          console.error(error);
          setPingDateTime('ERROR');
      }
    };
    
  useEffect(() => {        
    fetchPlaylists();
  }, []);

  useEffect(() => {        
    if (swiperInit) {
      console.log('swiperInit true')
    }
  }, [swiperInit]);

  function loadImage(e, image) {
    e.target.src = image;
}


  useEffect(() => {
    if (swiperInit) {

      var timeoutArray = [];

      var swiperElems = document.getElementsByClassName('swiper-container');
      // var swiperElems = swiper;
      var numSwipers = swiperElems.length;

      function runSlides(numSwipers, swiperIndex, delayVal){
        if (!TEST_MODE) pingDisplay();
        var delay = delayVal;
        var currIndex = swiperElems[swiperIndex].swiper.activeIndex;
        var slidesLength = parseInt(swiperElems[swiperIndex].dataset.length);
        
        if (currIndex === (slidesLength - 1)) {
          var newSlideIndex = 0;
        } else {
          var newSlideIndex = currIndex + 1;
        }
       
        if (swiperIndex !== (numSwipers - 1)) {
          var newSwiperIndex = swiperIndex + 1;
        } else {
          var newSwiperIndex = 0;
        }

        setAnimInit(true);

        const swiperTimeout = setTimeout(() => {
          // console.log('runSlides', {currIndex: currIndex, slidesLength: slidesLength, newSlideIndex: newSlideIndex, newSwiperIndex: newSwiperIndex});
          swiperElems[swiperIndex].swiper.slideTo(newSlideIndex);

          if (paused) {
          } else {
            runSlides(numSwipers, newSwiperIndex, delay);
          }
        }, delayVal);
        setTimeouts(swiperTimeout);
        return () => clearTimeout(swiperTimeout);

      }

      if (paused) {
      } else {
        runSlides(numSwipers, 0, delay);
      }
      
    }


   
  }, [swiperInit, medias, paused, transitionEffect, delay])


  useEffect(() => {
    console.log(medias);
  }, [medias])

  useEffect(() => {
    if ((pingDateTime !== 'ERROR') && (pingDateTime !== null)) {
      console.log('ping', pingDateTime);
    } else {
      if (pingDateTime === 'ERROR') {
        window.location.reload(false);
      }
    }
  }, [pingDateTime])

  useEffect(() => {
    if (TEST_MODE) return;
    function checkDisplaySettings() {
      const get_url = base_url + '/api/display-media/1/?format=json';
      axios({
          method: 'get',
          url: get_url,
          // headers: {
          //   Authorization: 'Token ' + Cookies.get('ud_token')
          // },
      })
      .then(response => {
          const displayJSON = response.data;
          if ((displayModified)&&(modified)) {

            
            if (displayJSON['modified'] > modified) {
              setModified(displayJSON['modified']);
              setPaused(displayJSON['paused']);
              //  console.log('modified: true', displayJSON['modified'], modified);

               
            } else {
              if (displayJSON['display_modified'] > displayModified) {
                setDisplayModified(displayJSON['display_modified']);
                setPaused(displayJSON['paused']);
                // console.log('checkDisplaySettings: true', displayJSON['display_modified'], displayModified, displayJSON['modified'], modified);
              } else {
                setPaused(displayJSON['paused']);
                // console.log('checkDisplaySettings: false', displayJSON['paused'], displayModified, displayJSON['modified'], modified);
              }
 
            }

          }
      });
    }

    setInterval(() => {
      checkDisplaySettings();
    }, 1000 * 5);

  }, [animInit])

  useEffect(() => {
    if (animInit) {
      if (paused) {
        console.log('paused changed: true', paused);
        clearTimeout(timeouts);
        setSwiperInit(false);

      } else {
        console.log('paused changed: false', paused);
        setSwiperInit(true);
      }
    }
  }, [paused, modified])


  useEffect(() => {
    if (animInit) {
      if (modified) {
        window.location.reload(false);
      } else {
      }
    }
  }, [modified])
  


  return (
    <section className="mainPage" id="playerPage">
        {frames && frames.length > 0 && frames.map((frame, i) => {
          var isCombinedRow = SCRAMBLE_ENABLED && i === 3;
          return (
          <div className={"carousel" + (isCombinedRow ? " combined" : "")} key={'frame_' + i}>
            {(medias && medias.length > 0 && medias[i]) ? (

              <div className="swiper-container" data-length={medias[i].length} id={"swiper_" + i}
                style={isCombinedRow ? {height: COMBINED_VH + 'vh'} : undefined}>
                <div className="swiper-wrapper">
                  {medias[i].map((item, j) =>
                    <div className="swiper-slide" key={'image_' + j}>
                      {isCombinedRow ? (
                        <div className="scramble-container">
                          {SCRAMBLE_SEGMENTS.map((slice, k) => (
                            <div
                              key={k}
                              className="scramble-slice"
                              style={{
                                top: toVh(slice.y) + 'vh',
                                height: toVh(slice.h) + 'vh',
                                transform: slice.flip ? 'scaleY(-1)' : 'none',
                              }}
                            >
                              <div style={{marginTop: -toVh(slice.srcY) + 'vh'}}>
                                <img
                                  src={Loader}
                                  onLoad={(e) => loadImage(e, item.row4.get_image)}
                                  className={"slideImage" + ((item.row4.is_portrait)?(' portrait'):(''))}
                                  style={{height: SINGLE_ROW_VH + 'vh', display: 'block'}}
                                  alt=""
                                />
                                <img
                                  src={Loader}
                                  onLoad={(e) => loadImage(e, item.row5.get_image)}
                                  className={"slideImage" + ((item.row5.is_portrait)?(' portrait'):(''))}
                                  style={{height: SINGLE_ROW_VH + 'vh', display: 'block'}}
                                  alt=""
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <img src={Loader} onLoad={(e) => loadImage(e, item.get_image)} className={"slideImage" + ((item.is_portrait)?(' portrait'):(''))} alt="" />
                      )}
                    </div>
                  )}
                </div>
              </div>
            ):null}
          </div>
        )})}
    </section>
  )

}
export default App;

